import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import 'react';
import PropTypes from 'prop-types';
import StartLayoutContainer$1 from '../../Layouts/StartLayoutContainer.js';
import { jsx } from '@emotion/react';
var _excluded = ["children"];
var StartLayoutContainer = function StartLayoutContainer(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  return jsx(StartLayoutContainer$1, _extends({
    px: 4,
    mb: 4
  }, props), children);
};
StartLayoutContainer.propTypes = {
  children: PropTypes.node
};
StartLayoutContainer.defaultProps = {
  children: null
};
export { StartLayoutContainer as default };